import { Button, Div, Text } from '@sendoutcards/quantum-design-ui'
import React from 'react'
import { CardFragment } from 'src/graphql/generated/graphql'
import { ThreeDCardPreview } from '@sendoutcards/editor'
import {
  get3DCardPreviewStandardProps,
  mapPanelControlNames,
} from 'src/helpers/threeDCard/mapPanelImages'
import { Dialog } from 'src/design_system/molecules/dialog/Dialog'
import styles from './cardPreviewModal.module.scss'

interface CardPreviewModalProps {
  isOpen: boolean
  onClose: () => void
  itemIndex: number
  card: CardFragment
  onEditCard?: (card: CardFragment) => void
  onReplaceCard: (cardId: string) => void
}

const CardPreviewModal: React.FC<CardPreviewModalProps> = props => {
  const { isOpen, onClose, itemIndex, card, onReplaceCard, onEditCard } = props
  const isMobileWindow = window.innerWidth <= 588
  const headingAlignment = isMobileWindow ? 'center' : undefined
  const descriptionType = isMobileWindow ? '.75rem' : '.875rem'
  const actionSize = isMobileWindow ? 'xSmall' : 'small'

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      wrapperStyle={{
        overflow: 'hidden',
        ...(isMobileWindow ? { display: 'flex', flexDirection: 'column' } : {}),
      }}
      padding="initial"
      title={
        itemIndex === -1
          ? `Bulk Order Card: ${card.detailedSendableCard?.title}`
          : `Card ${itemIndex + 1}: ${card.detailedSendableCard?.title}`
      }
      mobileOpenHeight="0"
    >
      <div className={styles.introText}>
        <Div maxWidth="465px" inset={{ top: 'x1' }}>
          <Text
            type={'body'}
            content="Preview your card and choose if you would like to edit the current card or delete the card you have created"
            lineHeight={1.2}
            alignment={headingAlignment}
            style={{ fontSize: descriptionType }}
          />
        </Div>
      </div>
      <Div
        display="flex"
        width="100%"
        justifyContent="center"
        outset={{ bottom: 'x2' }}
      >
        <div className={styles.tdcpWrapper}>
          <ThreeDCardPreview
            {...get3DCardPreviewStandardProps(card)}
            height={isMobileWindow ? '250px' : '300px'}
            maxWidth="100%"
            maxHeight="50dvh"
            minWidth="200px"
            control={{
              type: 'Standard',
              panelNames: mapPanelControlNames(card.panels),
              shouldOnlyShowDropdown: isMobileWindow,
            }}
            shouldDisplayDataMatrix={!!!card.digitalCard}
            shouldNotScaleBackpanel={true}
          />
        </div>
      </Div>
      <div className={styles.actionSection}>
        <Button
          type="danger"
          size={actionSize}
          title="Replace card"
          onClick={() => onReplaceCard?.(card.id)}
          outlined={true}
        />
        <Button
          id="make_changes_to_your_card"
          type="secondary"
          size={actionSize}
          title="Make Changes to your card"
          onClick={() => onEditCard?.(card)}
        />
      </div>
    </Dialog>
  )
}
export default CardPreviewModal
